// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"440b2a09","513":"99364678","703":"e5ff8025","787":"00d2cc49"}[chunkId] + ".chunk.js";
};